import axios from 'axios';

class ApiClient {
  
    constructor(authToken) {
        this.authToken = authToken;
       
    }
    async fetchData(url, method = 'POST', data = {}) {
      
        try {
            let response;
            const headers = { 'Authorization': `Bearer ${this.authToken}` };
            if (method.toUpperCase() === 'GET') {
              response = await axios.get(url, {headers});
            } else if (method.toUpperCase() === 'POST') {
              response = await axios.post(url, data, {headers});
             
              
            } else {
              console.error('Unsupported HTTP method');
              throw new Error('Unsupported HTTP method');
            }
            console.info('response**',response);
            if(url.includes("/payment/payOrder")){
              return response.data
            }
            if(url.includes("/subscription")){
              return response.data
            }
            return response.data.data;
          } catch (error) {
            console.log('Error',error.response);
            return error.response.data.data;
          }
    }

    // Add more methods for different API calls as needed
}

export default ApiClient;
